import React, { useCallback, useState } from "react";

const useFlashcastTable = () => {
  const [searchTerm, setSearchTerm] = useState<string>();

  const handleSearchSubmit = useCallback(
    (e?: React.FormEvent, setGlobalFilter?: (v: string) => void) => {
      if (e) e.preventDefault();
      if (setGlobalFilter) setGlobalFilter(searchTerm);
    },
    [searchTerm]
  );
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };


  return {
    handleSearchSubmit,
    searchTerm,
    handleSearchChange,
  };
};

export default useFlashcastTable;
